import AddressForm from "kinnect-front/Address/AddressForm";
import DefaultLayout from "@/layouts/DefaultLayout";
import { Address } from "kinnect-models";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";

export default {
	name: "CustomerAddressPage",

	metaInfo() {
		const title = this.editing && this.fetched
			? `Customers - Addresses - ${this.address.alias}`
			: "Customers - Addresses - Add a Customer";

		return { title: this.fetched ? title : null };
	},

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	props: {
		idCustomer: {
			required: true,
			type: Number
		},
		idAddress: Number
	},

	data: () => ( {
		crud: "addresses",
		address: null,
		deleteDialogOpen: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idAddress );
		},

		genDeleteDialog() {
			if ( this.editing && this.address && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete address" )}
					onConfirm={this.deleteAddress}
					redirect={[ "back", {
						name: "customer",
						params: { idCustomer: this.idCustomer }
					} ]}
					title="Delete Address"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the customer address <strong>{this.address.alias}</strong> at <strong>{this.address.address}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Address",
					tooltip: "Delete this customer address"
				};
			}
		}
	},

	methods: {
		deleteAddress() {
			const address = new Address( { id: this.idAddress } );

			return address.delete();
		},

		async fetchAddress() {
			if ( this.editing ) {
				this.address = await new Address()
				.findPageModel( this.idAddress );
			}
		},

		async fetch() {
			await this.fetchAddress();
		}
	},

	render() {
		return <DefaultLayout maxWidth="600px">
			<AddressForm
				address={this.address}
				idCustomer={this.idCustomer}
				loading={this.$wait.is( "find address" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
			></AddressForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
